module.exports = __webpack_public_path__ + "assets/img/JoinTeam.eff586c4.png";